module.exports = __webpack_public_path__ + "cm.4982702b.svg";